module.exports = __webpack_public_path__ + "static/img/summon-conquer.bbc68b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/summon-conquer.jpg
// module id = T5lT
// module chunks = 0